/** Every route path in one place, so links cannot drift from the router. */
export const routes = {
  login: '/login',
  forcedPassword: '/login/change-password',

  overview: '/',
  download: '/download',
  batch: '/batch',
  batchRun: (id: string) => `/batch/${id}`,

  explorer: '/explorer',
  explorerProfile: (platform: string, id: string) => `/explorer/p/${platform}/${encodeURIComponent(id)}`,
  explorerSaved: '/explorer/saved',
  explorerFolder: (id: string) => `/explorer/saved/${id}`,
  explorerLiked: '/explorer/liked',

  projects: '/projects',
  projectNew: '/projects/new',
  project: (id: string) => `/projects/${id}`,
  editor: (id: string) => `/projects/${id}/edit`,

  libraryDownloads: '/library/downloads',
  libraryExports: '/library/exports',

  activity: '/activity',
  workspaces: '/workspaces',

  accountProfile: '/account/profile',
  accountSecurity: '/account/security',
  accountApi: '/account/api',
  accountDevices: '/account/devices',
  accountMusic: '/account/music',
  accountCredits: '/account/credits',

  support: '/support',

  adminUsers: '/admin/users',
  adminUser: (id: string) => `/admin/users/${id}`,
  adminIntegrations: '/admin/integrations',
  adminFeedback: '/admin/feedback',
} as const;

export const FEATURE_KEYS = {
  explorer: 'profile_explorer',
  editor: 'video_editor',
} as const;
